const About = () => import("@/components/Admin/Pages/About");
const Contact = () => import("@/components/Admin/Pages/Contact");
const Import = () => import("@/components/Admin/Pages/Import");
const Errors = () => import("@/components/Admin/Pages/ErrorLog");
const Limits = () => import("@/components/Admin/Pages/Limits");

const routes = [
  {
    name: "About",
    path: "/about",
    component: About,
    meta: {
      title: "About",
      sidebar: true
    }
  },
  {
    name: "Contact",
    path: "/contact",
    component: Contact,
    meta: {
      title: "Contact Us",
      sidebar: true
    }
  },
  {
    name: "Import",
    path: "/import",
    component: Import,
    meta: {
      title: "Import",
      sidebar: true
    }
  },
  {
    name: "Errors",
    path: "/error-log",
    component: Errors,
    meta: {
      title: "Errors Log",
      sidebar: true
    }
  },
  {
    name: "ManageLimits",
    path: "/manage-limits",
    component: Limits,
    meta: {
      title: "Manage Limits",
      sidebar: true
    }
  }
];

export default routes;
